<template>
  <div v-if="item" class="legajo-detalle">
    <div v-if="titulo" class="legajo-detalle__head">
      <div class="legajo-detalle__identidad">
        <div class="legajo-detalle__foto">
          <img v-if="fotoUrl" :src="fotoUrl" alt="Foto">
          <v-icon v-else size="36" color="#94a3b8">mdi-account-circle-outline</v-icon>
        </div>
        <div>
          <div class="legajo-detalle__nombre">{{ item.apellidosNombres || 'Personal' }}</div>
          <div class="legajo-detalle__meta">
            {{ item.clinica || '—' }} · DNI {{ item.dniCe || '—' }} · {{ item.cargo || '—' }}
          </div>
        </div>
      </div>
      <v-chip small label :class="item.estado ? 'chip-ok' : 'chip-off'">
        {{ item.estado ? 'Activo' : 'Inactivo' }}
      </v-chip>
    </div>
    <div v-else-if="fotoUrl" class="legajo-detalle__foto-solo">
      <img :src="fotoUrl" alt="Foto del personal">
    </div>

    <v-alert v-if="perfilLabel" type="info" dense outlined class="mb-3">
      Vista según perfil: <strong>{{ perfilLabel }}</strong>
    </v-alert>

    <div v-for="sec in seccionesVisibles" :key="sec.id" class="cp-consulta-sec">
      <div class="cp-consulta-sec__title">
        <v-icon small color="#0b5cad" class="mr-1">{{ sec.icon }}</v-icon>
        {{ sec.title }}
      </div>
      <div class="cp-consulta-grid">
        <div v-for="field in sec.fields" :key="field.key" class="cp-consulta-row">
          <span class="cp-consulta-row__label">{{ field.label }}</span>
          <span class="cp-consulta-row__value">{{ displayValor(field) || '—' }}</span>
        </div>
      </div>
    </div>

    <div v-if="!seccionesVisibles.length" class="legajo-detalle__empty">
      Su perfil no tiene campos habilitados para consulta.
    </div>
  </div>
</template>

<script>
import {
  normalizarLegajoRrhh,
  sincronizarCalculados,
  valorCampoLegajo,
  seccionesParaPerfil,
  resolverPerfilLegajo,
  PERFILES_LEGAJO,
} from './rrhhLegajo'

export default {
  name: 'LegajoDetalleLectura',
  props: {
    item: { type: Object, default: null },
    perfilSlug: { type: String, default: '' },
    titulo: { type: Boolean, default: true },
  },
  computed: {
    perfilActivo() {
      return this.perfilSlug || resolverPerfilLegajo()
    },
    perfilLabel() {
      const cfg = PERFILES_LEGAJO[this.perfilActivo]
      return cfg ? cfg.label : this.perfilActivo
    },
    registro() {
      if (!this.item) return null
      const f = normalizarLegajoRrhh(this.item)
      sincronizarCalculados(f)
      return f
    },
    seccionesVisibles() {
      return seccionesParaPerfil(this.perfilActivo)
    },
    fotoUrl() {
      return (this.registro && this.registro.datos && this.registro.datos.foto) || ''
    },
  },
  methods: {
    displayValor(field) {
      if (!this.registro) return ''
      return valorCampoLegajo(this.registro, field)
    },
  },
}
</script>

<style src="../control-prestaciones/cp-page.css"></style>
<style scoped>
.legajo-detalle__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
}
.legajo-detalle__identidad {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  min-width: 0;
}
.legajo-detalle__foto {
  width: 72px;
  height: 72px;
  border-radius: 12px;
  overflow: hidden;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.legajo-detalle__foto img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.legajo-detalle__foto-solo {
  width: 96px;
  height: 96px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
}
.legajo-detalle__foto-solo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.legajo-detalle__nombre {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
}
.legajo-detalle__meta {
  font-size: 0.85rem;
  color: #64748b;
  margin-top: 0.2rem;
}
.legajo-detalle__empty {
  text-align: center;
  color: #64748b;
  padding: 2rem 1rem;
}
.cp-consulta-sec {
  margin-bottom: 1.25rem;
}
.cp-consulta-sec__title {
  font-weight: 600;
  font-size: 0.9rem;
  color: #0f172a;
  margin-bottom: 0.5rem;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #e2e8f0;
}
.cp-consulta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.35rem 1rem;
}
.cp-consulta-row__label {
  display: block;
  font-size: 0.72rem;
  color: #64748b;
}
.cp-consulta-row__value {
  font-size: 0.88rem;
  color: #0f172a;
}
</style>
